import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const helpMenuIconClasses = generateClasses('HelpMenuIcon', ['root'] as const);
export const helpMenuIconRootClasses = generateClasses(helpMenuIconClasses.root, ['hideIcon'] as const, true);

export const helpMenuIconStyles: Styles = ({ theme }) => {
  const {
    appHeader: { iconColor, elementHoverBackgroundColor },
  } = getAppFrameTheme(theme);
  return {
    [`&.${helpMenuIconClasses.root}`]: {
      width: 48,
      height: 48,
      borderRadius: 0,
      color: iconColor,

      [`&.${helpMenuIconRootClasses.hideIcon}`]: {
        display: 'none',
      },
      '&:hover': {
        background: elementHoverBackgroundColor,
      },
    },
  };
};

export const helpMenuClasses = generateClasses('HelpMenu', ['root', 'paper', 'contextTitle'] as const);

const styles: Styles = ({ theme: { spacing } }) => {
  return {
    [`.${helpMenuClasses.paper}`]: {
      [`.${helpMenuClasses.contextTitle}`]: {
        margin: spacing(1, 2),
        fontWeight: 500,
        lineHeight: '24px',
      },
    },
  };
};

export default styles;
